import React from "react";
import { useParams } from "react-router-dom"
import { getCityById, loadWeather } from "../utils/utils"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

import Title from "../Components/Title"
import WeatherRecap from "../Components/WeatherRecap";

import { Navigate } from 'react-router-dom'

import { useSelector, useDispatch } from "react-redux"
import { pushCity, removeCity } from "../features/favuriteCity";
import {pushChron} from '../features/chronology'
import { IconButton } from "@mui/material";
import WeatherDaily from "../Components/WeatherDaily";
import WeatherDayGraph from "../Components/WeatherDayGraph";
import GeoMap from "../Components/GeoMap";
import CityMap from "../Components/CityMap";
import SimpleWhiteBox from "../Components/SimpleWhiteBox";
import { Skeleton } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Collapse } from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WhiteCard from "../Components/WhiteBox";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';


export default function City() {
  const weather = useSelector(state => state.weather.weather)
  const cityId = useParams().cityId
  
  const city = getCityById(cityId)
  if (city === -1) {
    return (
      <Navigate to="/home" />
    )
  }
  
  if (!(cityId in weather)) {
    loadWeather(city)
  }

  return (
    <div>
      <RenderCity weather={weather[cityId]} />
    </div>
  )
}

function RenderCity(props) {
  const weather = props.weather
  const favuriteList = useSelector(state => state.favuriteCity.list)
  const isFavurite = weather && favuriteList.filter(i => i.id == weather.weather.city.id).length > 0
  return (
    <div>
      {
        weather ? 
          <>
            <LoadCity weather={weather.weather} favurite={isFavurite} />
          </>
          :
          <div style={{ alignItems: 'center', textAlign: 'center' }}>
            <br />
            <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
            <br />
            <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
            <br />
            <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
            <br />
            <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
            <br />
            <Skeleton variant="rectangular" width="90%" height={118} style={centerStyle} />
          </div>
      }
    </div>
  )
}

const centerStyle = {marginLeft:'auto', marginRight:'auto'}

function LoadCity(props) {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dispatch = useDispatch()

  const day0 = new Date()
  const day1 = new Date()
  day1.setDate(day1.getDate() + 1)
  const day2 = new Date()
  day2.setDate(day2.getDate() + 2)
  const day3 = new Date()
  day3.setDate(day3.getDate() + 3)
  const day4 = new Date()
  day4.setDate(day4.getDate() + 4)
  const day5 = new Date()
  day5.setDate(day5.getDate() + 5)
  const day6 = new Date()
  day6.setDate(day6.getDate() + 6)

  const handleToggleFavurite = () => {
    isFavurite ? 
      dispatch(removeCity(weather.city.id))
      :
      dispatch(pushCity(weather.city))
  }
  
  

  const weather = props.weather
  dispatch(pushChron(weather.city))
  const isFavurite = props.favurite
  return (
    <div className="container">
      <hr />
      <div className="row">
        <div className="col-10">
          <Title title={weather.city.name} />
        </div>
        <div className="col-2">
          <IconButton onClick={handleToggleFavurite}>
            {
              isFavurite ? 
                <StarRoundedIcon />
                :
                <StarBorderRoundedIcon />
            }
          </IconButton>
        </div>
      </div>
      <hr />
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
            <Tab label="Oggi" {...a11yProps(0)} />
            <Tab label="Domani" {...a11yProps(1)} />
            <Tab label={printDate(2)} {...a11yProps(2)} />
            <Tab label={printDate(3)} {...a11yProps(3)} />
            <Tab label={printDate(4)} {...a11yProps(4)} />
            <Tab label={printDate(5)} {...a11yProps(5)} />
            <Tab label={printDate(6)} {...a11yProps(6)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
        <WeatherDayGraph weather={filterDayInDate(day0, weather.hourly)} />
          <WeatherDaily weather={filterDayInDate(day0, weather.daily)} min={true} />
          <WeatherRecap weather={filterDayInDate(day0, weather.hourly)} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <WeatherDayGraph weather={filterDayInDate(day1, weather.hourly)} />
          <WeatherDaily weather={filterDayInDate(day1, weather.daily)} min={true} />
          <WeatherRecap weather={filterDayInDate(day1, weather.hourly)} />
          
        </TabPanel>
        <TabPanel value={value} index={2}>
          <WeatherDayGraph weather={filterDayInDate(day2, weather.hourly)} />
          <WeatherDaily weather={filterDayInDate(day2, weather.daily)} min={false} />
          <WeatherRecap weather={filterDayInDate(day2, weather.hourly)} />
          
        </TabPanel>
        <TabPanel value={value} index={3}>
          <WeatherDaily weather={filterDayInDate(day3, weather.daily)} min={false} />
          
        </TabPanel>
        <TabPanel value={value} index={4}>
          <WeatherDaily weather={filterDayInDate(day4, weather.daily)} min={false} />
          
        </TabPanel>
        <TabPanel value={value} index={5}>
          <WeatherDaily weather={filterDayInDate(day5, weather.daily)} min={false} />
          
        </TabPanel>
        <TabPanel value={value} index={6}>
          <WeatherDaily weather={filterDayInDate(day6, weather.daily)} min={false} />
          
        </TabPanel>
      </Box>
      <CityMap city={weather.city} />
      <div style={{display:'block', height:'80px'}}></div>

    </div>
  )
}

function AccordationIn(props) {
  const items = props.items;
  console.log(items)
  return (
    <div>
      {
        items.map(i => {
          return <SingleAccordion key={i.title} title={i.title} content={i.content} />
        })
      }
    </div>
  )
}

function SingleAccordion(props) {
  const [expanded, setExpanded] = React.useState(props.isExpanded)

  return (
    <div>
      <WhiteCard id={props.title} content={
        <div>
            <p>{props.title}</p>
        </div>
      }
        selected={() => { setExpanded(!expanded) }} icon={expanded ? <ArrowBackIosNewRoundedIcon style={{ transform: 'rotate(90deg)' }} /> : <ArrowBackIosNewRoundedIcon style={{ transform: 'rotate(-90deg)' }} />}
      />
      <Collapse in={expanded}>
        {props.content}
      </Collapse>
    </div>

  )
}

function printDate(daysToAdd) {
  let d = new Date()
  d.setDate(d.getDate() + daysToAdd)
  return d.getDate().toString().padStart(2, '0') + '/' + (d.getMonth()+ 1).toString().padStart(2, '0') + '/' + d.getFullYear()
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component='div'>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function filterDayInDate(dateForFilter, list) {
  return list.filter(el => {
    let d = new Date(el.dt * 1000)
    return dateForFilter.getDate() == d.getDate() && dateForFilter.getMonth() == d.getMonth() && dateForFilter.getFullYear() == d.getFullYear()
  })
}